<script setup lang="ts">
import { onMounted, ref, watch, computed } from 'vue'
import { Calendaricon } from 'Common/components/elements/icons/Icons'
import { formatDate, formatDayByDate,  formatTimeByDate} from '@/common/utils/formatDate';


interface PropTypes {
    inspections 
    inspectionInstanceUuid,
    selected
}


const instanceA  = ref()
const instanceB = ref()
const inspectionDates = computed(() => {
  return props.inspections?.map(inspection=>{
    return {
      value: inspection.startDate,
      label: inspection.startDate,
    }
  })
})

const emits = defineEmits<{
  (e: 'onSelected', value): void
}>()

onMounted(()=>{
    instanceB.value = props.selected

    const otherInspections = inspectionDates.value.filter(inspection=>inspection.inspectionInstanceUuid===props.inspectionInstanceUuid[0])
    const previousInspection = otherInspections.length ? otherInspections[0]: null
    instanceB.value = previousInspection 
})

const props = defineProps<PropTypes>()

watch(()=>props.inspections, (): void => {
    if(!props.inspections) return

    const currentInspectionindex = props.inspections.findIndex(inspection=>inspection?.inspectionInstanceUuid===props.inspectionInstanceUuid[0])
    // setCurrent inspection as inspectionA
    instanceA.value = props.inspections[currentInspectionindex] 

    const otherInspections = inspectionDates.value.filter(inspection=>inspection.inspectionInstanceUuid!==props.inspectionInstanceUuid[0])
    const previousInspection = otherInspections.length ? otherInspections[0]: null
    instanceB.value = previousInspection 
})

watch(()=>props.selected, (): void => {
    instanceB.value = props.selected
})

const getInspectionStepWrapperClass = (inspection) => {
  if (props.inspectionInstanceUuid === inspection.inspectionInstanceUuid) {
    return 'text-orange-300'
  }
  if (instanceB.value?.startDate === inspection.startDate) {
    return 'text-purple-500'
  }
  return 'cursor'
}

const dateSelectedHandler = (instance)=>{
    instanceB.value = instance
    emits('onSelected', instance)
}

</script>

<template>
    <div>
        <el-space direction="horizonal" alignment="center" :size="30"></el-space>
        <el-steps  align-center class="pt-4">
            <el-step
v-for="inspection in props.inspections" 
            :key="inspection.inspectionInstanceUuid" 
            status="wait" >

            <template #icon>
                <slot>
                <div :class="`${getInspectionStepWrapperClass(inspection)}`"  @click="dateSelectedHandler(inspection)">
                    <Calendaricon/>
                </div>
                </slot>
            </template>

            <template #title>
                <slot>
                <div :class="`${getInspectionStepWrapperClass(inspection)}`" @click="dateSelectedHandler(inspection)">
                    {{ formatDayByDate(inspection.startDate) }}
                </div>
                </slot>
            </template>

            <template #description>
                <slot>
                <div :class="`${getInspectionStepWrapperClass(inspection)}`"  @click="dateSelectedHandler(inspection)">
                    {{ formatTimeByDate(inspection.startDate) }}
                </div>
                </slot>
            </template>
            </el-step>
        </el-steps>
    </div>
</template>
<style>
.cursor{
    cursor: pointer;
}

</style>